import type { QuotationForClient } from '~/api/quotations/types';
import type { routes } from '~/providers/RouterProvider/router.routes';
import type { Params } from '~/providers/RouterProvider/router.types';

import { quotationForClientQueryOptions } from '~/api/quotations/useQuotationForClient';
import { queryClient } from '~/providers/QueryClientProvider/queryClient';

export const loader = async ({
  params,
}: {
  params: Params<typeof routes.quotationForClient>;
}): Promise<{ approvalKey: string; quotationForClient: QuotationForClient }> => {
  const approvalKey = params.approvalKey;

  const quotationForClient = await queryClient.query({ ...quotationForClientQueryOptions(approvalKey), staleTime: 'static' });

  return { approvalKey, quotationForClient };
};
